import React from 'react';
import { IconProps } from './model/IconInterface';

const ShekelIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M4 20V4h10.7v10" />
      <path d="M20 4v16H9.3V10" />
    </svg>
  );
};

export default ShekelIcon;
